import { register } from '@shopify/theme-sections'
import '../../styles/sections/index-finance-block.scss'
import $ from 'jquery'
import 'slick-carousel'

export default register(`index-finance-block`, {
  onLoad() {
    // will inherit the slick slider settings defined in the data attributes
    $(`.finance-block-slider`).slick()
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
  },
})
